import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  fieldsContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '10px',
  },
  textfield: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '12px',
    width: '250px',
  },
  checkboxContainer: {
    marginTop: '20px',
    marginBottom: '30px',
  },
}));

const FormDettagliNuovoEsercizio = ({
  handleChange,
  record,
  textFieldsDisabled,
  validationErrors,
}) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      className={classes.sectionContainer}
    >
      <Grid container className={classes.fieldsContainer}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid
            container
            direction="column"
            alignItems="center"
            className={classes.gridContainer}
          >
            <TextField
              label="Nome*"
              value={record.esercizio.nome ?? ''}
              name="nome"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
              helperText={validationErrors.nome}
              error={validationErrors.nome.length > 0}
            />
            <TextField
              label="Ragione sociale*"
              value={record.esercizio.ragioneSociale ?? ''}
              name="ragioneSociale"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
              helperText={validationErrors.ragioneSociale}
              error={validationErrors.ragioneSociale.length > 0}
            />
            <TextField
              label="Partita IVA"
              value={record.esercizio.partitaIva ?? ''}
              name="partitaIva"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Codice ATECO"
              value={record.esercizio.codiceAteco ?? ''}
              name="codiceAteco"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Telefono"
              value={record.esercizio.telefono ?? ''}
              name="telefono"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Nome titolare"
              value={record.esercizio.nomeGestore ?? ''}
              name="nomeGestore"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Cognome titolare"
              value={record.esercizio.cognomeGestore ?? ''}
              name="cognomeGestore"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Email titolare*"
              value={record.esercizio.emailGestore ?? ''}
              name="emailGestore"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
              helperText={validationErrors.emailGestore}
              error={validationErrors.emailGestore.length > 0}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid
            container
            direction="column"
            alignItems="center"
            className={classes.gridContainer}
          >
            <TextField
              label="Telefono titolare"
              value={record.esercizio.telefonoGestore ?? ''}
              name="telefonoGestore"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Indirizzo"
              value={record.esercizio.indirizzoSede ?? ''}
              name="indirizzoSede"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Numero civico"
              value={record.esercizio.numeroSede ?? ''}
              name="numeroSede"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Città"
              value={record.esercizio.cittaSede ?? ''}
              name="cittaSede"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Provincia"
              value={record.esercizio.provinciaSede ?? ''}
              name="provinciaSede"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="Codice SDI"
              value={record.esercizio.codiceSdi ?? ''}
              name="codiceSdi"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
            <TextField
              label="PEC"
              value={record.esercizio.pec ?? ''}
              name="pec"
              onChange={handleChange}
              className={classes.textfield}
              disabled={textFieldsDisabled}
            />
          </Grid>
        </Grid>
      </Grid>
      {/*
     // da levare il commento appena si ripristina la gestione operativa separata
       <Grid item xs={12} className={classes.checkboxContainer}>
        <FormControlLabel
          control={
            <Checkbox
              name="gestioneOperativaSeparata"
              color="primary"
              checked={record.esercizio.gestioneOperativaSeparata || false}
              onChange={handleChange}
            />
          }
          label=" Selezionare la casella per gestione operativa separata dal manuale"
          disabled={textFieldsDisabled}
        />
      </Grid> */}
    </Grid>
  );
};

FormDettagliNuovoEsercizio.propTypes = {
  handleChange: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  textFieldsDisabled: PropTypes.bool.isRequired,
  validationErrors: PropTypes.object.isRequired,
};

export default FormDettagliNuovoEsercizio;
